module.exports = __webpack_public_path__ + "static/img/LiveBg01.5fdd907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LiveBg01.png
// module id = RK3m
// module chunks = 101